module.exports = __webpack_public_path__ + "resources/icon-warning.21bfe8b74cd0974f.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/notice-bar/img/icon-warning.png
// module id = 576
// module chunks = 0 1 2 3